

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { StatutoryHolidaySetup } from "../../components/StatutoryHolidaySetup";
import { BCEHTSettingSetup } from "../../components/BCEHTSettingSetup";


export const BCEHTSettingSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="BC EHT Settings"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "BC EHT Settings", navigateTo: "/bc-eht-setting" }
      ]}
      mainContents={<BCEHTSettingSetup />}
    />
  );
};
